import { render } from "./TemplateMasterBook.vue?vue&type=template&id=e3436f50"
import script from "./TemplateMasterBook.vue?vue&type=script&lang=js"
export * from "./TemplateMasterBook.vue?vue&type=script&lang=js"
script.render = render

export default script